import React from "react";
import { Dialog } from "primereact/dialog";
import AddingNewCountry from "../add-area/add-country";
 
interface AddCountryPageProps {
  showAddCountryModal: boolean;
  hideAddCountryModal: () => void;
  onSuccess: () => void;  // Add this prop type
}
 
const AddCountryPage: React.FC<AddCountryPageProps> = ({
  showAddCountryModal,
  hideAddCountryModal,
  onSuccess
}) => {
  return (
    <Dialog
      visible={showAddCountryModal}
      className="quickview"
      breakpoints={{ "1400px": "45vw", "641px": "80vw" }}
      modal
      header="Add Country Hierarchy"
      onHide={hideAddCountryModal}
    >
 
 
{/* <AddingNewCountry onSuccess={() => refreshData()} /> */}
<AddingNewCountry/>
    </Dialog>
   
   
  );
};
 
export default AddCountryPage;
 
 